import React, {FC, useEffect, useState} from 'react'
import { DoctorTable } from './components/DoctorTable';
import axios from 'axios'
import { Auth } from 'aws-amplify';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_DOCTOR_URL = `${API_URL_API}/getAllDoctorsForAdmins`


const DoctorList: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [doctors, setDoctors] = useState([]);


  useEffect(() => {
    getAllDoctor()
  },[])


  const getAllDoctor = async () => {
    
    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      const {data: result} = await axios.get(GET_ALL_DOCTOR_URL,{
        headers : {
          Authorization: `Bearer ${token}`
        }
      });
        setDoctors(result.data);
        
        SetLoading(false);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
               <DoctorTable doctors={doctors} getAllDoctor={getAllDoctor} className='mb-5 mb-xl-8' /> 
          )
        }

          
        </>
  )
}

export {DoctorList}
